import { Box } from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { fileUrl } from 'api/api'
import { showModal } from 'app/slice/modal.slice'
import BtnProfile from 'component/Treatments/BtnProfile'
import PopupPatientDetail from 'component/Treatments/PopupPatientDetail'
import { imgs } from 'constants/images'
import { colors } from 'constants/theme'
import { getClinicInfo } from 'utils/app.utils'

type PopupType = 'treatment' | 'payment' | 'historyTreatment' | 'overdue' | 'lab-order' | 'retrospective' | 'xray'

interface PatientProfileCardProps {
  patient: any
  type?: PopupType
  isNotShownPhone?: boolean
}

const PatientProfileCard = ({ patient, type = 'historyTreatment', isNotShownPhone }: PatientProfileCardProps) => {
  const dispatch = useDispatch()
  const branch = getClinicInfo()
  const [isShowPopupDetail, setIsShowPopupDetail] = useState<boolean>(false)

  if (!patient || !patient.patientId) return null

  const handlePatientCode = () => {
    if (branch?.patientCodeQueue === '1') return patient.cnNumber || ''
    if (branch?.patientCodeQueue === '0') return patient.branchCnNumber || ''
    if (branch?.patientCodeQueue === '2') return patient.snCode || ''
    return patient.cnNumber || patient.branchCnNumber || ''
  }

  const profileSrc = patient.profilePath && patient.profileName
    ? `${fileUrl}/${patient.profilePath}/${patient.profileName}`
    : imgs.defaultAvatar

  const onViewHistory = () => {
    dispatch(showModal())
    setIsShowPopupDetail(true)
  }

  return (
    <>
      <Box
        className="d-flex align-items-center px-3"
        onClick={onViewHistory}
        sx={{
          cursor: 'pointer',
          padding: '10px 16px',
          minHeight: 80,
          backgroundColor: colors.white,
          border: '1px solid #e5e5e5',
          boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <BtnProfile
          profile={profileSrc}
          branchCnNumber={handlePatientCode()}
          firstName={patient.firstname}
          lastName={patient.lastname}
          firstnameEn={patient.firstnameEn}
          lastnameEn={patient.lastnameEn}
          displayName={patient.displayName}
          rankId={patient.rankId}
          lastVisit={patient.updatedAt}
        />
      </Box>
      <PopupPatientDetail
        showPopup={isShowPopupDetail}
        patient={patient}
        profile={profileSrc}
        type={type}
        isNotShownPhone={isNotShownPhone}
        onClose={() => setIsShowPopupDetail(false)}
      />
    </>
  )
}

export default PatientProfileCard
